import { useMemo } from 'preact/hooks';
import { encode } from 'uqr';

/**
 * The address to open on a phone: this page as a standalone app (no embed
 * mode), keeping the tenant, lead source and utm tags.
 */
export function phoneUrl(loc: Location = location): string {
  const url = new URL(loc.href);
  url.searchParams.delete('embed');
  url.hash = '';
  return url.href;
}

/**
 * "On a computer? Scan to use your phone's camera." Shown only to mouse
 * users (pointer: fine), i.e. desktops and laptops; phones and tablets never
 * see it.
 */
export function PhoneQr() {
  const qr = useMemo(() => {
    const { data, size } = encode(phoneUrl(), { ecc: 'M', border: 2 });
    let d = '';
    data.forEach((row, y) => row.forEach((on, x) => on && (d += `M${x} ${y}h1v1h-1z`)));
    return { d, size };
  }, []);

  return (
    <aside class="mt-6 hidden items-center gap-5 rounded-2xl bg-paper p-4 pointer-fine:flex" data-testid="phone-qr">
      <svg
        viewBox={`0 0 ${qr.size} ${qr.size}`}
        class="h-32 w-32 shrink-0 rounded-lg bg-white"
        shape-rendering="crispEdges"
        role="img"
        aria-label="QR code that opens this visualizer on your phone"
      >
        <path d={qr.d} fill="#000" />
      </svg>
      <div>
        <p class="text-base font-semibold">Use your phone's camera</p>
        <p class="mt-1 text-sm leading-snug text-muted">
          Scan this code with your phone or tablet to open the visualizer there, then snap a photo of your floor.
        </p>
      </div>
    </aside>
  );
}
